import React, { useEffect, useState } from "react";
import { IconButton, TextField, Tooltip, Typography } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import "./selectWithSearch.less";

export default function SelectWithAutoSearch({
  labelHeading = "",
  keyValue = "",
  isRequired = false,
  disabled = false,
  toolTip = "",
  id = "",
  txtName = "",
  onChange = () => {},
  optionsList = [],
  keyForMapping = "StateName",
  //selectedValue = "",
  clearFilterData = false,
  defaultValue = null,
  reloadData = false,
  onInputValueChange = () => {}
}) {
  const [selectedOptions, setSelectedOptions] = useState("");

  /** styling functions */
  useEffect(() => {
    setSelectedOptions("");
  }, [clearFilterData]);
  useEffect(() => {
    setSelectedOptions(defaultValue);
  }, [reloadData]);

  /**
   * call on input box value change
   * @param {*} keyValue 
   * @param {*} value 
   */
  const onInputChange = (keyValue, value) => {
    setSelectedOptions(value);
    onChange(keyValue, value[keyForMapping]);
  };
  return (
    <Autocomplete
      freeSolo
      className={"search-box-wrapper"}
      // PaperComponent={({ children }) => (
      //   <Paper style={{ fontSize:'1rem !important'  }}>{children}</Paper>
      // )}
      // sx={{
      //   '& .MuiAutocomplete-option': {
      //     fontSize: '1rem !important '
      //   }
      // }}
      size={"small"}
      underlineStyle={{ display: "none" }}
      onChange={(event, value) =>
        keyValue ? onInputChange(keyValue, value) : onChange(event)}
      onInputChange={(event, value) => {
        event != null && value != null
          ? onInputValueChange(keyValue, value)
          : null;
      }}
      id={"tags-standard"}
      value={selectedOptions || ""}
      options={optionsList || []}
      //.map((option) => option[keyForMapping])}
      getOptionLabel={option => option[keyForMapping]}
      renderOption={option => (
        <Typography style={{ fontSize: "1rem" }}>
          {option[keyForMapping]}
        </Typography>
      )}
      renderInput={params => (
        <TextField
          {...params}
          // value={selectedValue}
          autoComplete={"off"}
          inputProps={{ ...params.inputProps, style: { fontSize: "5rem" } }}
          InputLabelProps={{ style: { pointerEvents: "auto" } }}
          id={id}
          name={txtName}
          label={
            <div className={"labelWidth"}>
              <span>
                {" "}
                <b>{labelHeading} </b>
              </span>

              {isRequired && <span className={"requiredFldText"}>{" *"}</span>}
              {toolTip && (
                <Tooltip title={toolTip}>
                  <IconButton
                    id={"iconBtn"}
                    size={"small"}
                    className={"tooltip-iconSize"}
                  >
                    <InfoOutlined fontSize={"inherit"} />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          }
          disabled={disabled}
        />
      )}
    />
  );
}
